import { useQuery } from "react-query";
import { getAgreementType } from "../../../../actions/Utilities/AgreementType";

export const useAgreementType = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetAgreementType",
    getAgreementType,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
